import axios from "functions/axios";

export const GetTicketList = ({ myTicket, status, page = 1, page_size = 15 }) =>
  axios
    .get("chat/admin/list/", {
      params: { page, page_size, myTicket, status },
    })
    .then((res) => res.data);

export const GetTicketDetails = (id) =>
  axios.get(`chat/admin/retrieve/?pk=${id}`).then((res) => res.data);

export const AnswerTicket = (data) =>
  axios.post("chat/admin/message/create/", data).then((res) => res.data);

export const EditTicketMessage = ({ messageID, data }) =>
  axios.put(`chat/admin/message/edit/${messageID}/`, data).then((res) => res.data);

export const DeleteTicket = (chatroom_id) =>
  axios.post("chat/admin/close/", { chatroom_id }).then((res) => res.data);
